import { Registry } from '../../loader/di/registry.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';
import { ADHESION_UNIT_WATCHER } from '../token.js';
import { EffectFunction } from './index.js';

export const SCROLL_IN_CONTAINER: EffectFunction = ({ adserverContainer, containerNode }: Adslot) => {
    const adhesionUnitWatcher = Registry.lookup(ADHESION_UNIT_WATCHER);

    adserverContainer.classList.add('sdgSticky');
    const interval: number = window.setInterval(() => {
        const adhesionUnit = adhesionUnitWatcher.getAdhesionUnit();
        if (adhesionUnit.isActive) {
            adserverContainer.style.top = `${adhesionUnit.height}px`;
        }
    }, 250);

    containerNode.classList.add("sdgScrollInContainer");

    return () => {
        window.clearInterval(interval);
        adserverContainer?.classList.remove('sdgSticky');
        containerNode?.classList.remove('sdgScrollInContainer');
    };
};
